import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { hideAppSpinner, showAppMessage, showAppSpinner } from '@rainbow-modules/app';
import useHttpMutation from 'data/firestore/useHttpMutation';
import { BaseFormProps } from './types';
import FormFooter from './footer';
import Form from './form';
import { Container, Content } from './styled';

interface CreateFormProps extends BaseFormProps {
    onSuccess?: (response: unknown) => void;
}

const CreateForm = ({
    agentId = '',
    onSuccess,
    onRequestClose = () => {},
    ...rest
}: CreateFormProps) => {
    const navigate = useNavigate();
    const {
        mutateAsync: createResponder,
    } = useHttpMutation<Record<string, unknown>, Record<string, unknown>>({
        pathname: `/agents/${agentId}/llms`,
        method: 'POST',
        onSuccess: (response) => {
            onRequestClose();
            if (onSuccess) {
                onSuccess(response);
                return;
            }
            navigate(`/${agentId}/llms/${response.id}`);
        },
    });

    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            try {
                showAppSpinner();
                await createResponder({
                    body: {
                        ...values,
                    },
                });
            } catch (error) {
                showAppMessage({
                    variant: 'error',
                    message: (error as Error).message,
                    timeout: 5000,
                });
            }
            hideAppSpinner();
        },
        [createResponder],
    );

    return (
        <Container>
            <Content>
                <Form
                    {...rest}
                    id="responder-form"
                    onSubmit={handleSubmit}
                />
            </Content>
            <FormFooter
                formId="responder-form"
                onCancelClick={onRequestClose}
            />
        </Container>
    );
};

export default CreateForm;
